import ArchiveIcon from '../../../../icons/delete.svg'
import DocumentIcon from '../../../../icons/document.svg'
import EmailIcon from '../../../../icons/email.svg'
import RestoreIcon from '../../../../icons/restore.svg'
import BookViewingIcon from '../../../../icons/viewing.svg'

export const QA_NAME_APPLICANT_PROFILE_FOOTER_ADD_NEW =
  'applicantProfileHeaderAddNew'

export const QA_NAME_APPLICANT_PROFILE_FOOTER_MORE =
  'applicantProfileHeaderActionMore'

export const APPLICANT_PROFILE_FOOTER_ACTION = {
  bookViewing: 'bookViewing',
  document: 'document',
  email: 'email',
}

export const APPLICANT_PROFILE_FOOTER_ACTION_ITEMS = [
  {
    Icon: DocumentIcon,
    action: APPLICANT_PROFILE_FOOTER_ACTION.document,
  },
  {
    Icon: EmailIcon,
    action: APPLICANT_PROFILE_FOOTER_ACTION.email,
  },
  {
    Icon: BookViewingIcon,
    action: APPLICANT_PROFILE_FOOTER_ACTION.bookViewing,
  },
]

export const APPLICANT_PROFILE_FOOTER_ACTION_TEXT_KEY = {
  [APPLICANT_PROFILE_FOOTER_ACTION.bookViewing]:
    'RentalPortal.ListingProfileFooterBookViewingBtnKey',
  [APPLICANT_PROFILE_FOOTER_ACTION.document]:
    'RequestProfile.HeaderFooterUploadButtonKey',
  [APPLICANT_PROFILE_FOOTER_ACTION.email]:
    'RequestProfile.HeaderFooterEmailButtonKey',
}

export const APPLICANT_PROFILE_FOOTER_ACTION_QA_NAME = {
  [APPLICANT_PROFILE_FOOTER_ACTION.bookViewing]:
    'applicantProfileHeaderActionBookViewing',
  [APPLICANT_PROFILE_FOOTER_ACTION.document]:
    'applicantProfileHeaderActionDocument',
  [APPLICANT_PROFILE_FOOTER_ACTION.email]: 'applicantProfileHeaderActionEmail',
}

export const APPLICANT_PROFILE_FOOTER_ACTION_PERMISSION_NAME = {
  [APPLICANT_PROFILE_FOOTER_ACTION.bookViewing]: 'can_manage',
  [APPLICANT_PROFILE_FOOTER_ACTION.document]: 'can_manage',
  [APPLICANT_PROFILE_FOOTER_ACTION.email]: 'can_manage',
}

export const APPLICANT_PROFILE_FOOTER_MASKED_ACTIONS = [
  APPLICANT_PROFILE_FOOTER_ACTION.bookViewing,
]

export const APPLICANT_PROFILE_FOOTER_UNAVAILABLE_TOOLTIP_KEY = {
  [APPLICANT_PROFILE_FOOTER_ACTION.document]:
    'RentalPortal.ApplicantProfileFooterDocumentUnavailableTooltipKey',
}

export const APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION = {
  archive: 'archive',
  restore: 'restore',
}

export const APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_ICON = {
  [APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.archive]: ArchiveIcon,
  [APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.restore]: RestoreIcon,
}

export const APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_TEXT_KEY = {
  [APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.archive]:
    'RentalPortal.ApplicantProfileArchiveBtnKey',
  [APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.restore]:
    'RentalPortal.ApplicantProfileRestoreBtnKey',
}

export const APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_QA_NAME = {
  [APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.archive]:
    'applicantProfileHeaderActionArchive',
  [APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.restore]:
    'applicantProfileHeaderActionRestore',
}

export const APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION_PERMISSION_NAME = {
  [APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.archive]: 'can_archive',
  [APPLICANT_PROFILE_FOOTER_LIFECYCLE_ACTION.restore]: 'can_restore',
}
